import { IconBaseProps } from "react-icons/lib";
import { FaUser } from "react-icons/fa6";
import { roles } from "..";
import { Box } from "@mui/material";

// Use coins dollar svg as mask to colorize consistently
import CoinsMask from "../../assets/svgs/coins_dollar.svg";
// import ScenarioMask from "../../assets/svgs/scenario_modeling.svg";

// Import new SVG icon components
import {
  PostImportIcon,
  PartnersIcon as PartnerIcon,
  ClientsIcon as ClientIcon,
  ScenarioModelingIcon,
} from "../../components/sidebar-icons";

// New SVG assets (use CSS mask so we can color active/inactive)
import ProductHubSvg from "../../assets/images/sidebar/new-icons/product-hub.svg";
import DutyCalculatorSvg from "../../assets/images/sidebar/new-icons/duty-calculator.svg";
import TradeDataSvg from "../../assets/images/sidebar/new-icons/TradeData.svg";
import DocumentsSvg from "../../assets/images/sidebar/new-icons/documents.svg";
import ClientsSvg from "../../assets/images/sidebar/new-icons/clients.svg";
import SettingsSvg from "../../assets/images/sidebar/new-icons/settings.svg";
import AnalyticsSvg from "../../assets/images/sidebar/new-icons/analytics.svg";
import ChatAdvisorSvg from "../../assets/images/sidebar/new-icons/chat-advisor.svg";

// Top-level items (no nested Dashboard). Keep Documents nested.
const HOME_COMMON = [
  {
    href: `/dashboard/analytics`,
    icon: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#1cb4ba", WebkitMask: `url(${AnalyticsSvg}) no-repeat center / contain`, mask: `url(${AnalyticsSvg}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#8e9494", WebkitMask: `url(${AnalyticsSvg}) no-repeat center / contain`, mask: `url(${AnalyticsSvg}) no-repeat center / contain` }} />
    ),
    title: "Analytics",
  },
  {
    href: `/dashboard/potential/first-sale`,
    icon: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#1cb4ba", WebkitMask: `url(${CoinsMask}) no-repeat center / contain`, mask: `url(${CoinsMask}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#8e9494", WebkitMask: `url(${CoinsMask}) no-repeat center / contain`, mask: `url(${CoinsMask}) no-repeat center / contain` }} />
    ),
    title: "Potential Savings",
  },
  {
    href: `/scenario-modeling`,
    icon: <ScenarioModelingIcon color="#1cb4ba" />,
    icon2: <ScenarioModelingIcon color="#8e9494" />,
    title: "Scenario Modeling",
  },
  {
    href: `/chat-advisor`,
    icon: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#1cb4ba", WebkitMask: `url(${ChatAdvisorSvg}) no-repeat center / contain`, mask: `url(${ChatAdvisorSvg}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#8e9494", WebkitMask: `url(${ChatAdvisorSvg}) no-repeat center / contain`, mask: `url(${ChatAdvisorSvg}) no-repeat center / contain` }} />
    ),
    title: "Riffs Intelligence",
  },
  {
    href: `/product-catalogue`,
    icon: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#1cb4ba", WebkitMask: `url(${ProductHubSvg}) no-repeat center / contain`, mask: `url(${ProductHubSvg}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#8e9494", WebkitMask: `url(${ProductHubSvg}) no-repeat center / contain`, mask: `url(${ProductHubSvg}) no-repeat center / contain` }} />
    ),
    title: "Product Hub",
  },
  {
    href: `/duty-calculator`,
    icon: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#1cb4ba", WebkitMask: `url(${DutyCalculatorSvg}) no-repeat center / contain`, mask: `url(${DutyCalculatorSvg}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#8e9494", WebkitMask: `url(${DutyCalculatorSvg}) no-repeat center / contain`, mask: `url(${DutyCalculatorSvg}) no-repeat center / contain` }} />
    ),
    title: "Duty Calculator",
  },
  {
    href: `/trade-data`,
    icon: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#1cb4ba", WebkitMask: `url(${TradeDataSvg}) no-repeat center / contain`, mask: `url(${TradeDataSvg}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#8e9494", WebkitMask: `url(${TradeDataSvg}) no-repeat center / contain`, mask: `url(${TradeDataSvg}) no-repeat center / contain` }} />
    ),
    title: "Trade Data",
  },
  {
    href: `/documents`,
    icon: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#1cb4ba", WebkitMask: `url(${DocumentsSvg}) no-repeat center / contain`, mask: `url(${DocumentsSvg}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 19, height: 19, bgcolor: "#8e9494", WebkitMask: `url(${DocumentsSvg}) no-repeat center / contain`, mask: `url(${DocumentsSvg}) no-repeat center / contain` }} />
    ),
    title: "Documents",
    children: [
      { title: "Creation", href: "/documents/creation/certificate-of-origin" },
      { title: "Storage", href: "/documents/storage/entry-summary" },
    ],
  },
  {
    href: `/post-import-adjustment`,
    icon: <PostImportIcon color="#1cb4ba" />,
    icon2: <PostImportIcon color="#8e9494" />,
    title: "Post Import Adjustment",
  },
];

const OTHERS_COMMON = [
  {
    href: `/settings/account-settings`,
    icon: (
      <Box sx={{ width: 20, height: 20, bgcolor: "#1cb4ba", WebkitMask: `url(${SettingsSvg}) no-repeat center / contain`, mask: `url(${SettingsSvg}) no-repeat center / contain` }} />
    ),
    icon2: (
      <Box sx={{ width: 20, height: 20, bgcolor: "#8e9494", WebkitMask: `url(${SettingsSvg}) no-repeat center / contain`, mask: `url(${SettingsSvg}) no-repeat center / contain` }} />
    ),
    title: "Settings",
  },
];

const SPOWNERItems = {
  home: [...HOME_COMMON],
  others: [
    {
      href: `/partners`,
      icon: <PartnerIcon color="#1cb4ba" />,
      icon2: <PartnerIcon color="#8e9494" />,
      title: "Partners",
    },
    {
      href: `/clients`,
      icon: (
        <Box sx={{ width: 20, height: 20, bgcolor: "#1cb4ba", WebkitMask: `url(${ClientsSvg}) no-repeat center / contain`, mask: `url(${ClientsSvg}) no-repeat center / contain` }} />
      ),
      icon2: (
        <Box sx={{ width: 20, height: 20, bgcolor: "#8e9494", WebkitMask: `url(${ClientsSvg}) no-repeat center / contain`, mask: `url(${ClientsSvg}) no-repeat center / contain` }} />
      ),
      title: "Clients",
    },
    ...OTHERS_COMMON,
  ],
};

const SPPARTNERItems = {
  home: [...HOME_COMMON],
  others: [...OTHERS_COMMON],
};

const SPCLIENTItems = {
  home: [...HOME_COMMON],
  others: [...OTHERS_COMMON],
};

const TDCLIENTItems = {
  home: [
    ...HOME_COMMON,
    {
      href: `/users`,
      icon: <ClientIcon color="#1cb4ba" />,
      icon2: <ClientIcon color="#8e9494" />,
      title: "Users",
    },
  ],
  others: [...OTHERS_COMMON],
};

const TDADMINItems = {
  home: [...HOME_COMMON],
  others: [
    {
      href: `/tenant-management`,
      icon: <ClientIcon color="#1cb4ba" />,
      icon2: <ClientIcon color="#8e9494" />,
      title: "Tenant Management",
    },
    ...OTHERS_COMMON,
  ],
};

export const SidebarItems = {
  SPOWNER: { ...SPOWNERItems },
  SPPARTNER: { ...SPPARTNERItems },
  SPCLIENT: { ...SPCLIENTItems },
  TDCLIENT: { ...TDCLIENTItems },
  TDADMIN: { ...TDADMINItems },
};

export const SETTINGS_MENU = [
  {
    title: "Account Settings",
    link: "account-settings",
    icon: (props: IconBaseProps) => <FaUser {...props} />,
  },
  // {
  //   title: "Change Log",
  //   link: "changelog",
  //   icon: (props: IconBaseProps) => <CiCircleList {...props} />,
  // },
];

export const getSpClientHomeItems = (user: IUser) => {
  const allowedPages = user?.allowedPages;
  const show = (key: string, fallback = true) =>
    allowedPages ? allowedPages.includes(key) : fallback;
  return HOME_COMMON.filter((route) => {
    switch (route.title) {
      case 'Analytics':
        return show('ANALYTICS', true);
      case 'Potential Savings':
        return show('POTENTIAL_SAVINGS', true);
      case 'Scenario Modeling':
        return show('SCENARIO_MODELING', true);
      case 'Riffs Intelligence':
        return show('CHAT_ASSISTANCE', true);
      case 'Product Hub':
        return show('PRODUCT_HUB', true);
      case 'Duty Calculator':
        return show('PRODUCT_HUB', true);
      case 'Trade Data':
        return show('TRADE_DATA', true);
      case 'Documents':
        return show('DOCUMENTS', true);
      case 'Post Import Adjustment':
        return show('POST_IMPORT_ADJUSTMENT', true);
      default:
        return true;
    }
  });
};

export const getTDAdminOtherItems = (user: IUser, selectedTenant: ITenant | undefined) => {
  const isTDAdminSP =
    user?.userRole === roles.TDADMIN &&
    selectedTenant?.tenantType === "SERVICE_PROVIDER";

  let items = [
    {
      href: `/tenant-management`,
      icon: <ClientIcon color="#1cb4ba" />,
      icon2: <ClientIcon color="#8e9494" />,
      title: "Tenant Management",
    },
    ...OTHERS_COMMON,
  ];

  if (isTDAdminSP) {
    // Create new array with Partners and Clients at the beginning
    items = [
      {
        href: `/partners`,
        icon: <PartnerIcon color="#1cb4ba" />,
        icon2: <PartnerIcon color="#8e9494" />,
        title: "Partners",
      },
      {
        href: `/clients`,
        icon: <ClientIcon color="#1cb4ba" />,
        icon2: <ClientIcon color="#8e9494" />,
        title: "Clients",
      },
      ...items,
    ];
  }

  return items;
};

// TD Client: only show Users when current user is ADMIN
export const getTdClientHomeItems = (user: IUser, tenantPages?: string[]) => {
  const isAdmin = user?.accessLevel === 'ADMIN';
  const userPages = user?.allowedPages;
  const allowedKeys = userPages ?? tenantPages;

  const show = (key: string, fallback = true) =>
    allowedKeys ? allowedKeys.includes(key) : fallback;

  const items = HOME_COMMON.filter((route) => {
    switch (route.title) {
      case 'Analytics':
        return show('ANALYTICS', true);
      case 'Potential Savings':
        return show('POTENTIAL_SAVINGS', true);
      case 'Scenario Modeling':
        return show('SCENARIO_MODELING', true);
      case 'Riffs Intelligence':
        return show('CHAT_ASSISTANCE', true);
      case 'Product Hub':
        return show('PRODUCT_HUB', true);
      case 'Duty Calculator':
        return show('PRODUCT_HUB', true);
      case 'Trade Data':
        return show('TRADE_DATA', true);
      case 'Documents':
        return show('DOCUMENTS', true);
      case 'Post Import Adjustment':
        return show('POST_IMPORT_ADJUSTMENT', true);
      default:
        return true;
    }
  });
  if (isAdmin) {
    items.push({
      href: `/users`,
      icon: <ClientIcon color="#1cb4ba" />,
      icon2: <ClientIcon color="#8e9494" />,
      title: "Users",
    });
  }
  return items;
};

// SP Owner: filter by allowedPages when present
export const getSpOwnerHomeItems = (user: IUser) => {
  const allowedPages = user?.allowedPages;
  const show = (key: string, fallback = true) =>
    allowedPages ? allowedPages.includes(key) : fallback;
  return HOME_COMMON.filter((route) => {
    switch (route.title) {
      case 'Analytics':
        return show('ANALYTICS', true);
      case 'Potential Savings':
        return show('POTENTIAL_SAVINGS', true);
      case 'Scenario Modeling':
        return show('SCENARIO_MODELING', true);
      case 'Riffs Intelligence':
        return show('CHAT_ASSISTANCE', true);
      case 'Product Hub':
        return show('PRODUCT_HUB', true);
      case 'Duty Calculator':
        return show('PRODUCT_HUB', true);
      case 'Trade Data':
        return show('TRADE_DATA', true);
      case 'Documents':
        return show('DOCUMENTS', true);
      case 'Post Import Adjustment':
        return show('POST_IMPORT_ADJUSTMENT', true);
      default:
        return true;
    }
  }).map((r) => {
    return r;
  });
};

// SP Partner: filter by allowedPages when present (same as SP Owner)
export const getSpPartnerHomeItems = (user: IUser) => {
  return getSpOwnerHomeItems(user);
};

// Generic filter using explicit allowed keys
export const getHomeItemsByAllowedKeys = (allowedKeys: string[]) => {
  const show = (key: string) => allowedKeys.includes(key);
  return HOME_COMMON.filter((route) => {
    switch (route.title) {
      case 'Analytics':
        return show('ANALYTICS');
      case 'Potential Savings':
        return show('POTENTIAL_SAVINGS');
      case 'Scenario Modeling':
        return show('SCENARIO_MODELING');
      case 'Riffs Intelligence':
        return show('CHAT_ASSISTANCE');
      case 'Product Hub':
        return show('PRODUCT_HUB');
      case 'Duty Calculator':
        return show('PRODUCT_HUB');
      case 'Trade Data':
        return show('TRADE_DATA');
      case 'Documents':
        return show('DOCUMENTS');
      case 'Post Import Adjustment':
        return show('POST_IMPORT_ADJUSTMENT');
      default:
        return true;
    }
  });
};
